import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HomeAction from '../actions/HomeAction';
import TrackingParams from '../../components/tracking/TrackingParams/TrackingParams';

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    storePartner: HomeAction.storePartner
  }, dispatch);

const TrackingParamsContainer = connect(null, mapDispatchToProps)(TrackingParams);

export default TrackingParamsContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/TrackingParamsContainer.js
 **/